import React from 'react';
import '../styles/Breadcrumb.css';

interface BreadcrumbProps {
  onGoHome: () => void;
  showUploadNew?: boolean;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ 
  onGoHome, 
  showUploadNew
}) => {
  return (
    <nav className="breadcrumb">
      <button className="breadcrumb-item home" onClick={onGoHome}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        <span>Αρχική</span>
      </button>
      {showUploadNew && (
        <>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item breadcrumb-text">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
            <span>Ανέβασμα Νέου Αρχείου</span>
          </span>
        </>
      )}
    </nav>
  );
};

export default Breadcrumb;

